export var IntegrityErrorCode;
(function (IntegrityErrorCode) {
    IntegrityErrorCode["PLAY_SERVICES_NOT_FOUND"] = "PLAY_SERVICES_NOT_FOUND";
    IntegrityErrorCode["PLAY_STORE_NOT_FOUND"] = "PLAY_STORE_NOT_FOUND";
    IntegrityErrorCode["PLAY_SERVICES_VERSION_OUTDATED"] = "PLAY_SERVICES_VERSION_OUTDATED";
    IntegrityErrorCode["PLAY_STORE_VERSION_OUTDATED"] = "PLAY_STORE_VERSION_OUTDATED";
    IntegrityErrorCode["API_NOT_AVAILABLE"] = "API_NOT_AVAILABLE";
    IntegrityErrorCode["CANNOT_BIND_TO_SERVICE"] = "CANNOT_BIND_TO_SERVICE";
    IntegrityErrorCode["REQUEST_HASH_TOO_LONG"] = "REQUEST_HASH_TOO_LONG";
    IntegrityErrorCode["APP_NOT_INSTALLED"] = "APP_NOT_INSTALLED";
    IntegrityErrorCode["APP_UID_MISMATCH"] = "APP_UID_MISMATCH";
    IntegrityErrorCode["INTERNAL_ERROR"] = "INTERNAL_ERROR";
    IntegrityErrorCode["CLOUD_PROJECT_NUMBER_IS_INVALID"] = "CLOUD_PROJECT_NUMBER_IS_INVALID";
    IntegrityErrorCode["NETWORK_ERROR"] = "NETWORK_ERROR";
    IntegrityErrorCode["GOOGLE_SERVER_UNAVAILABLE"] = "GOOGLE_SERVER_UNAVAILABLE";
    IntegrityErrorCode["INTEGRITY_TOKEN_PROVIDER_INVALID"] = "INTEGRITY_TOKEN_PROVIDER_INVALID";
    IntegrityErrorCode["CLIENT_TRANSIENT_ERROR"] = "CLIENT_TRANSIENT_ERROR";
    IntegrityErrorCode["TOO_MANY_REQUESTS"] = "TOO_MANY_REQUESTS";
    IntegrityErrorCode["NO_ERROR"] = "NO_ERROR";
})(IntegrityErrorCode || (IntegrityErrorCode = {}));
export var AppRecognitionVerdict;
(function (AppRecognitionVerdict) {
    AppRecognitionVerdict["UNRECOGNIZED_VERSION"] = "UNRECOGNIZED_VERSION";
})(AppRecognitionVerdict || (AppRecognitionVerdict = {}));
export var AppLicensingVerdict;
(function (AppLicensingVerdict) {
    AppLicensingVerdict["UNLICENSED"] = "UNLICENSED";
})(AppLicensingVerdict || (AppLicensingVerdict = {}));
export var DeviceRecognitionVerdict;
(function (DeviceRecognitionVerdict) {
    DeviceRecognitionVerdict["MEETS_DEVICE_INTEGRITY"] = "MEETS_DEVICE_INTEGRITY";
    DeviceRecognitionVerdict["MEETS_VIRTUAL_INTEGRITY"] = "MEETS_VIRTUAL_INTEGRITY";
})(DeviceRecognitionVerdict || (DeviceRecognitionVerdict = {}));
